(function () {
    getVideos();
})();

function getVideoType(url) {
    if (url.endsWith(".webm")) return 'video/webm';
    if (url.endsWith(".ogg")) return 'video/ogg';
    return "video/mp4";
}

function sanitizeYouTubeURL(url) {
    try {
        const parsed = new URL(url, "https://www.youtube.com");
        const allowedHosts = ['www.youtube.com', 'youtube.com', 'youtu.be'];

        if (!allowedHosts.includes(parsed.hostname)) {
            return "";
        }

        parsed.protocol = "https:";
        parsed.search = "";
        parsed.hash = "";

        return parsed.origin + parsed.pathname;
    } catch (e) {
        return "";
    }
}

/**
 * Sanitize self-hosted url video
 */
function sanitizeVideoURL(url) {
    try {
        const parsed = new URL(url, window.location.origin);

        if (parsed.origin !== window.location.origin) {
            console.warn("Blocked external video URL:", parsed.href);
            return "";
        }

        parsed.protocol = "https:";
        return parsed.href;

    } catch (e) {
        return "";
    }
}

function getVideos() {
    let v = document.querySelectorAll(".oportun-image[data-yt-url]");

    for (var n = 0; n < v.length; n++) {
        let id = v[n].getAttribute("data-yt-url");
        let img = v[n].querySelector(".image img");
        let autoplay = v[n].getAttribute("data-yt-autoplay") === "1";

        const activateVideo = function() {
            var parent = this.parentNode;
            parent.classList.add('video');

            if (isYouTubeURL(id)) {
                createIframe(this, id, autoplay);
            } else {
                createVideoElement(this, id, autoplay);
            }
        };

        // Click
        img.addEventListener("click", activateVideo);

        // Keyboard (ENTER / SPACE)
        img.addEventListener("keydown", function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                activateVideo.call(this);
            }
        });

        if (autoplay) {
            activateVideo.call(img);
        }
    }
}

/**
 * Detect YouTube URL
 */
function isYouTubeURL(url) {
    try {
        const parsed = new URL(url, window.location.origin);
        return ['www.youtube.com', 'youtube.com', 'youtu.be'].includes(parsed.hostname);
    } catch {
        return false;
    }
}

/**
 * YouTube iframe
 */
function createIframe(v, url, autoplay) {
    const autoplayEnabled = autoplay === true;

    const videoParams = autoplayEnabled
        ? "?autoplay=1&mute=1&playsinline=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0"
        : "?autoplay=0&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0";

    var iframe = document.createElement("iframe");
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('src', sanitizeYouTubeURL(url) + videoParams);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('class', 'youtube-iframe');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

    v.replaceWith(iframe);
}

/**
 * Self-hosted video (muted by default)
 */
function createVideoElement(v, url, autoplay) {
    const video = document.createElement("video");

    video.setAttribute('class', 'self-video');
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('controls', '');

    video.muted = true;
    video.defaultMuted = true;

    video.controls = true;

    if (autoplay) {
        video.setAttribute('autoplay', "");
    }

    video.preload = 'none';

    const source = document.createElement("source");
    source.setAttribute('src', sanitizeVideoURL(url));
    source.setAttribute('type', getVideoType(url));

    video.appendChild(source);

    v.replaceWith(video);
}
